<template>
  <InputField
    v-model="password"
    :type="type"
    class="password-input"
    name="password"
    :label="label"
    hint="Password needs to have at least 8 characters"
    required
    :error="error"
    :autocomplete="autocomplete"
  >
    <template #right-icon>
      <IconButton
        class="password-input__button"
        size="md"
        flair="soft"
        kind="transparent"
        @click="onHideClick"
        @mouseenter="isHoveringIcon = true"
        @mouseleave="isHoveringIcon = false"
        @focus="isHoveringIcon = true"
        @blur="isHoveringIcon = false"
      >
        <Icon
          class="password-input__button__icon"
          :name="cloacked ? (isHoveringIcon ? 'mono-show' : 'duotone-show') : 'duotone-hide'"
        />
      </IconButton>
    </template>
  </InputField>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

import Icon from '@/uiKit/Icon/Icon.vue'
import IconButton from '@/uiKit/Button/IconButton.vue'
import InputField from '@/components/Common/InputField/V2/InputField.vue'

const props = withDefaults(
  defineProps<{
    modelValue?: string
    autocomplete?: string
    label?: string
    error?: string
  }>(),
  { modelValue: '', autocomplete: 'password', label: 'Password', error: '' },
)

const emit = defineEmits<{
  (event: 'update:modelValue', val: string): void
}>()

const isHoveringIcon = ref(false)
const type = ref<'text' | 'password'>('password')
const cloacked = computed(() => type.value === 'password')

const password = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

const onHideClick = (): void => {
  type.value = type.value === 'password' ? 'text' : 'password'
}
</script>

<style lang="scss" scoped>
.password-input__button {
  height: 28px;
  width: 28px;

  &__icon {
    color: var(--color-icon-subtle);
    transform: scale(1.25);
  }
}
</style>
